import * as React from 'react';

import Icon from '@ant-design/icons/lib/components/Icon';

const IPen = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
            <svg
            width="25"
            height="16"
            viewBox="0 0 25 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.89271 15.0689C5.05859 15.0689 4.34958 14.777 3.76567 14.1933C3.18177 13.6094 2.88982 12.9004 2.88982 12.0663H0.621094V2.23494C0.621094 1.75783 0.791021 1.34945 1.13088 1.00978C1.47054 0.669928 1.87893 0.5 2.35603 0.5H18.015L24.6211 6.92824V12.0663H22.5302C22.5302 12.9004 22.2383 13.6094 21.6543 14.1933C21.0704 14.777 20.3615 15.0689 19.5276 15.0689C18.6935 15.0689 17.9845 14.777 17.4006 14.1933C16.8167 13.6094 16.5247 12.9004 16.5247 12.0663H8.89531C8.89531 12.8965 8.60346 13.6046 8.01974 14.1904C7.43584 14.776 6.72683 15.0689 5.89271 15.0689ZM15.6572 6.03851H21.1289L17.1921 2.23494H15.6572V6.03851ZM9.00664 6.03851H13.9223V2.23494H9.00664V6.03851ZM2.35603 6.03851H7.2717V2.23494H2.35603V6.03851ZM5.89271 13.512C6.29753 13.512 6.6397 13.3723 6.91921 13.0928C7.19873 12.8133 7.33849 12.4711 7.33849 12.0663C7.33849 11.6614 7.19873 11.3193 6.91921 11.0398C6.6397 10.7602 6.29753 10.6205 5.89271 10.6205C5.48789 10.6205 5.14572 10.7602 4.8662 11.0398C4.58668 11.3193 4.44692 11.6614 4.44692 12.0663C4.44692 12.4711 4.58668 12.8133 4.8662 13.0928C5.14572 13.3723 5.48789 13.512 5.89271 13.512ZM19.5276 13.512C19.9324 13.512 20.2746 13.3723 20.5541 13.0928C20.8336 12.8133 20.9734 12.4711 20.9734 12.0663C20.9734 11.6614 20.8336 11.3193 20.5541 11.0398C20.2746 10.7602 19.9324 10.6205 19.5276 10.6205C19.1228 10.6205 18.7806 10.7602 18.5011 11.0398C18.2216 11.3193 18.0818 11.6614 18.0818 12.0663C18.0818 12.4711 18.2216 12.8133 18.5011 13.0928C18.7806 13.3723 19.1228 13.512 19.5276 13.512ZM2.35603 10.3313H3.5037C3.74987 9.98434 4.0795 9.68631 4.49261 9.43725C4.90553 9.188 5.37223 9.06337 5.89271 9.06337C6.41319 9.06337 6.8743 9.18241 7.27603 9.42048C7.67796 9.65855 8.01309 9.96217 8.28143 10.3313H17.1386C17.3848 9.98434 17.7143 9.68631 18.1272 9.43725C18.5403 9.188 19.0071 9.06337 19.5276 9.06337C20.0481 9.06337 20.5092 9.18241 20.9109 9.42048C21.3129 9.65855 21.648 9.96217 21.9163 10.3313H22.8862V7.77345H2.35603V10.3313Z"
              fill="#AEA9B1"
            />
          </svg>

        );
      }}
      {...props}
    />
  );
};

export default IPen;
